export function data() {
  return {
    isDebug: true,
    file: [],
    image: null,
    documentIds: [],
    previews: []
  }
}
